"use strict";


import './stele.less';
import './panel';

var req = require.context("./", true, /^(.*\.(js$))[^.]*$/im);
req.keys().forEach(function (key)
{
	req(key);
});


export default class SteleApp extends PF.App
{
	static get options()
	{
		return {
			// prodUrl: 'https://pvo.stele.nirdesign.org',
			prodUrl: '',
			// devUrl: 'https://pvo.stele.nirdesign.org',
			devUrl: '',
			dateDisplayFormat: 'DD.MM.YYYY',
			dateDbFormat: 'YYYY-MM-DD',
			dtDisplayFormat: 'DD.MM.YYYY HH:mm',
			dtDbFormat: 'YYYY-MM-DD HH:mm',

			routes: [],
			f7Config: {
				panel: {
					swipe: 'left',
					// swipeOnlyClose: 'false',
					leftBreakpoint: 1024,
					rightBreakpoint: 1294,
					swipeActiveArea: 20,
				},
				view: {
					pushState: true,
				},
				theme: 'md',
			},
			mapConfig: {
				controls: ['zoomControl', 'fullscreenControl', 'typeSelector', 'geolocationControl', 'rulerControl'],
				defaultCenter: [55.75416210320157, 37.61960252760581],
				defaultZoom: 11
			}
		};
	}

	get baseUrl()
	{
		return '';

	}

	init()
	{
		// console.log('app init');
		this.user = JSON.parse(window.localStorage.getItem('user')) || null;
		super.init();
	}

	DOMContentLoadedSlot()
	{
		super.DOMContentLoadedSlot();
		this.on('app-loaded', () => this.appLoaded());

		this.f7.init();

		if (this.user === null)
		{
			let hash = (window.location.hash + '').split('/');
			if (['polls', 'poll-questions-step', 'poll-questions-scroll', 'poll-end'].indexOf(hash[hash.length - 1]) == -1) {
				this.router.navigate('/sign-in');
			}
		}
		Highcharts.setOptions({
			chart: {
				style: {
					fontFamily: 'Roboto'
				}
			}
		});
		// this.ajax('/auth/get-session', {}, (response) => {
		// 	if (response.status === 'OK')
		// 		{
		// 		// app.fireNotice = new App.FireNotice();
		// 		this.signIn(response.data);
		// 		this.f7.init();
		//
		// 		}
		// 	else
		// 		{
		// 		this.f7.init();
		// 		this.router.navigate('/sign-in');
		// 		}
		// });
	}

	appLoaded()
	{
		// let panel = new App.Modules.Panel.Test({
		// 		dom: {
		// 			app: $('#app')
		// 		}
		// 	}
		// );
		this.managePanel();
		this.user = JSON.parse(window.localStorage.getItem('user'));
		this.panelState = PF.H.get(this.user, 'role.name', null, null, (v) => Util.ucfirst(v));
		if (this.panelState === undefined || this.panelState === null)
		{
			this.panelState = 'Default';
		}

		window.addEventListener('keydown', (e) =>
		{
			this.moveRect(e);
		});
	}


	// назначит действия на кнопки клавиатуры
	moveRect(e)
	{
		switch (e.keyCode)
		{
			case 27: //Escape
				if (app.popupRect !== undefined && app.popupRect.opened === true)
				{
					app.popupRect.close();
				}
				break;
			case 87: // w
				app.panelDisplay(1);
				break;
			case 83: // s
				app.panelDisplay(0);
				break;
		}
	} // moveRect

	managePanel()
	{
		app.on('change:panelState', () =>
		{
			if (app.get('panel.state') !== app.panelState)
			{
				// this.panelState = window.localStorage.setItem('panelState', app.panelState);
				if (app.panel !== undefined)
				{
					app.panel.destroy();
					app.panel = undefined;
				}
				if (app.panelState !== null && App.Modules.Panel[app.panelState] !== undefined)
				{
					app.panel = new App.Modules.Panel[app.panelState]();
				}
			}
		}, true);
	}

	can(permission)
	{
		if (permission === 'guest')
		{
			return true;
		}
		if (this.user !== null && permission === 'user')
		{
			return true;
		}

		if (permission in PF.get(this, 'user.permissions', {}, {}))
		{
			return true;
		}
		return false;
	}


	signIn(user)
	{
		this.user = user;
		window.localStorage.setItem('user', JSON.stringify(this.user));
		// this.router.navigate('/');

		// this.panelState = window.localStorage.getItem('panelState');

		this.panelState = PF.H.get(this.user, 'role.name', null, null, (v) => Util.ucfirst(v));

		if (this.panelState === undefined || this.panelState === null)
		{
			this.panelState = 'Default';
		}

		if (this.fireNotice !== undefined)
		{
			this.fireNotice.askSubscribe();
		}
		else
		{
			this.fireNotice = new App.FireNotice();
		}
	}

	signOut()
	{
		app.request('/auth/sign-out', {}, () =>
		{
			app.user = null;
			window.localStorage.setItem('user', JSON.stringify(app.user));
			this.panelState = null;
			app.router.navigate('/sign-in');
			app.router.clearPreviousHistory();
		});

	}

	panelDisplay($flag = 0)
	{
		this.navbarMain = PF.Dom.Node.findOne('#navbarMain');
		// console.log(this.navbarMain);
		if ($flag)
		{
			this.navbarMain.css('display', '');
			//
			let newVisibleBreakpoint = 0;
			if (768 <= PF.Dom.Node.findOne('#app').width() && PF.Dom.Node.findOne('#app').width() <= 1024)
			{
				newVisibleBreakpoint = 768;
			}
			else if (PF.Dom.Node.findOne('#app').width() > 1024)
			{
				newVisibleBreakpoint = 5000;
			}
			if (app.panel.collapseState == false)
			{
				app.panel.collapseState = true;
				app.panel.panel.params.visibleBreakpoint = newVisibleBreakpoint;
			}
			else
			{
				app.panel.collapseState = false;
				app.panel.panel.params.visibleBreakpoint = 1024;
			}
			app.panel.panel.visibleBreakpointResizeHandler();
			app.panel.panel.collapsedBreakpointResizeHandler();


		} else
		{
			this.navbarMain.css('display', 'none');
			//
			if (app.panel.panel.params.visibleBreakpoint != 5000 || app.panel.panel.params.collapsedBreakpoint != 5000)
			{
				app.panel.panel.params.visibleBreakpoint = 5000;
				app.panel.panel.params.collapsedBreakpoint = 5000;
				app.panel.panel.visibleBreakpointResizeHandler();
				app.panel.panel.collapsedBreakpointResizeHandler();
			}
		}
		//

	}
}

window.app = new SteleApp();



